import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppFloatingButton from "./components/WhatsAppFloatingButton";

import Home from "./pages/Home";
import LearnLanguage from "./pages/LearnLanguage";
import Services from "./pages/Services";
import WhoWeAre from "./pages/WhoWeAre";
import Blogs from "./pages/Blogs";
import Payment from "./pages/Payment";
import Contact from "./pages/Contact";
import German from "./pages/German";
import Spanish from "./pages/Spanish";
import Japanese from "./pages/Japanese";
import French from "./pages/French";
import Career from "./pages/Career";
import Testimonials from "./pages/Testimonials";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col bg-canvas text-ink">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/courses" element={<LearnLanguage />} />
            <Route path="/services" element={<Services />} />
            <Route path="/who-we-are" element={<WhoWeAre />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/german" element={<German />} />
            <Route path="/spanish" element={<Spanish />} />
            <Route path="/japanese" element={<Japanese />} />
            <Route path="/french" element={<French />} />
            <Route path="/career" element={<Career />} />
            {/* <Route path="/testimonials" element={<Testimonials />} /> */}
          </Routes>
        </main>
        <Footer />
        {/* <FloatingButtons /> */}
        <WhatsAppFloatingButton />
      </div>
    </BrowserRouter>
  );
}

export default App;
